module.exports = __webpack_public_path__ + "media/images/lb/091-d7ca6d9c2016ce76b05bc499caa3e60d.svg";